import { ReactElement, useMemo } from "react";
import { ONE_HOUR } from "@miplatform/constants";
import { calendarViewDay, calendarViews } from "./calendarViews";
import { ColumnHeaderProps, EventCardProps, SchedulerViewProps } from "./types";

export function MiScheduler({
  config = { increment: ONE_HOUR },
  data = [],
  buckets = [],
  users = [],
  view = calendarViewDay,
  date,
  hasModalOpen = false,
  time = null,
  dateRange = null,
  selectedTechnician,
  selectedUserId = null,
  eventClassName,
  setSelectedUserId = () => null,
  ColumnHeader = () => null,
  EventCard = () => null,
  onColumnHeaderClick = () => null,
  onColumnHeaderRefresh = () => null,
  onEventCreate = () => null,
  onEventUpdate = () => null,
  onDrag = () => null,
  onCardHover = () => null,
  attemptsLoading = new Set(),
  EmptyUser = () => null,
  zoom = 1,
  verticalBuckets = null,
}: Readonly<MiSchedulerProps>): ReactElement {
  const ViewComponent = useMemo(() => calendarViews[view], [view]);

  return (
    <ViewComponent
      data={data}
      buckets={buckets}
      increment={config.increment}
      users={users}
      groupBy={config.groupBy}
      time={time}
      selectedUserId={selectedUserId}
      setSelectedUserId={setSelectedUserId}
      selectedTechnician={selectedTechnician}
      eventClassName={eventClassName}
      ColumnHeader={ColumnHeader}
      EventCard={EventCard}
      EmptyUser={EmptyUser}
      hasModalOpen={hasModalOpen}
      onEventUpdate={onEventUpdate}
      onEventCreate={onEventCreate}
      onColumnHeaderClick={onColumnHeaderClick}
      onColumnHeaderRefresh={onColumnHeaderRefresh}
      date={date ?? undefined}
      dateRange={dateRange}
      onDrag={onDrag}
      onCardHover={onCardHover}
      attemptsLoading={attemptsLoading}
      zoom={zoom}
      verticalBuckets={verticalBuckets}
    />
  );
}

interface MiSchedulerProps
  extends Omit<SchedulerViewProps, "increment" | "groupBy"> {
  config?: {
    increment: number;
    groupBy?: string;
  };
  view?: keyof typeof calendarViews;
  ColumnHeader?: React.ComponentType<ColumnHeaderProps>;
  EventCard?: React.ComponentType<EventCardProps>;
  verticalBuckets?: React.ReactNode;
}
